import React from 'react'

import { Box } from '@mui/material'

type StepContentProps = {
  component: React.ComponentType<any>
  back?: (...args: any[]) => any
  next?: (...args: any[]) => any
}

const StepContent = ({ next, back, component: Component }: StepContentProps) => (
  <div>
    <Box sx={{ padding: '1rem' }}>
      <Component back={back} next={next} />
    </Box>
  </div>
)

export default StepContent
